import config from "../../../../globalconfig";
import axios from "axios";
import cookie from "../../../utils/cookie";

const generateHeaderWithToken = () => {
	let token = cookie.readCookie("lctoken");
	let adminToken = cookie.readCookie("superuser");
	let headersWithToken = {
		Token: token,
		"Content-Type": "application/json",
	};
	if (adminToken) {
		headersWithToken["AdminToken"] = adminToken;
	}
	return headersWithToken;
};


var APIClient = function () { };

APIClient.prototype = {
	getAggregatedReplyRatingCount: function (data, callback) {
		axios
			.post(config.server + "/getAggregatedReplyRatingCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFacebookReviewComments: function (data, callback) {
		axios
			.post(config.server + "/getFacebookReviewComments", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfanityCheck: function (data, callback) {
		axios
			.get(
				config.server +
				"/getProfanityCheck?searchTerm=" +
				data.searchTerm +
				"&profileId=" +
				data.profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	commentFacebookReview: function (data, callback) {
		axios
			.post(
				config.server + "/commentFacebookReview",
				data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSavedReplyGroups: function (profileId, searchTerm, callback) {
		axios
			.get(
				config.server +
				"/getSavedReplyGroups?profileId=" +
				profileId +
				"&searchTerm=" +
				searchTerm,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateReport: function (data, callback) {
		axios
			.post(config.server + "/updateReportConfiguration", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleBrands: function (data, callback) {
		axios
			.post(config.server + "/getBrands", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBrandDetails: function (data, callback) {
		axios
			.post(config.server + "/getBrandDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleBrandEditHistory: function (data, callback) {
		axios
			.post(config.server + "/getAppleBrandEditHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createLocationAsset: function (data, callback) {
		axios
			.post(config.server + "/createLocationAsset", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReport: function (profileId, reportId, callback) {
		axios
			.get(
				config.server +
				"/deleteReportConfiguration?profileId=" +
				profileId +
				"&reportId=" +
				reportId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteLocationTag: function (profileId, type, filterTagId, callback) {
		axios
			.get(
				config.server +
				"/deleteFilterTag?profileId=" +
				profileId +
				"&type=" +
				type +
				"&filterTagId=" +
				filterTagId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReportById: function (profileId, reportId, callback) {
		axios
			.get(
				config.server +
				"/getReportConfigurationById?profileId=" +
				profileId +
				"&reportId=" +
				reportId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReport: function (data, callback) {
		axios
			.post(config.server + "/getReportConfiguration", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewsOverview: function (data, callback) {
		axios
			.post(config.server + "/getReviewsOverview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewSummaryReport: function (data, callback) {
		axios
			.post(config.server + "/getReviewSummaryReport", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentOverview: function (data, callback) {
		axios
			.post(config.server + "/getSentimentOverview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentByTopic: function (data, callback) {
		axios
			.post(config.server + "/getSentimentByTopic", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentByTopicCSV: function (data, callback) {
		axios
			.post(config.server + "/getSentimentByTopicCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentOverviewCSV: function (data, callback) {
		axios
			.post(config.server + "/getSentimentOverviewCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getRecentReviews: function (data, callback) {
		axios
			.post(config.server + "/getRecentReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	zohoDeskSignUp: function (email, callback) {
		axios
			.post(config.server + "/zohoDeskSignUp", email, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getReviewAnalysis: function (data, callback) {
		axios
			.post(config.server + "/getReviewAnalysis", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCategories: function (data, callback) {
		axios
			.post(config.server + "/getReviewTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addNewCategory: function (data, callback) {
		axios
			.post(config.server + "/addOrphanReviewTag", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	delFullCategory: function (data, callback) {
		axios
			.post(config.server + "/deleteReviewTagFromProfile", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editFullCategory: function (data, callback) {
		axios
			.post(config.server + "/editProfileReviewTag", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addCategory: function (data, callback) {
		axios
			.post(config.server + "/addReviewTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	delCategory: function (data, callback) {
		axios
			.post(config.server + "/deleteReviewTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentReview: function (data, callback) {
		axios
			.post(config.server + "/getTopicBasedSentimentReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDatewiseSentimentHistogram: function (data, callback) {
		axios
			.post(config.server + "/getDatewiseSentimentHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getGoogleLocations: function (data, callback) {
		axios
			.post(config.server + "/getGoogleLocationInsights", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getAllLocationsHistogram: function (data, callback) {
		axios
			.post(config.server + "/fetchedAllLocationsHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	fetchedLocationsHistogram: function (data, callback) {
		axios
			.post(config.server + "/fetchedLocationsHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	downloadInvoice: function (invoiceId, callback) {
		axios
			.get(config.server + "/downloadInvoiceAsPdf?invoiceId=" + invoiceId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	listInvoices: function (profileId, limit, callback) {
		axios
			.get(
				config.server + "/listInvoices?profileId=" + profileId + "&limit=100",
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteSubscription: function (profileId, callback) {
		axios
			.get(config.server + "/deleteSubscription?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	cancelSubscription: function (profileId, callback) {
		axios
			.get(config.server + "/cancelSubscription?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	refreshAccount: function (data, callback) {
		axios
			.post(config.server + "/refreshAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	disableAccount: function (data, callback) {
		axios
			.get(
				config.server +
				"/deleteAccount?profileId=" +
				data.profileId +
				"&accountId=" +
				data.accountId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	logout: function (token, callback) {
		axios
			.get(config.server + "/logout", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updatePaymentOwner: function (profileId, userId, callback) {
		axios
			.get(
				config.server +
				"/updatePaymentOwner?profileId=" +
				profileId +
				"&updateUserId=" +
				userId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getPaymentDetails: function (profileId, callback) {
		axios
			.get(config.server + "/getPaymentDetails?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	//     getProfileLocationCount: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	getHostPage: function (profileId, callback) {
		axios
			.get(config.server + "/getHostPagePayment?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	// zohoDeskSignUp: function (email, callback) {
	//     var token = cookie.readCookie("lctoken");
	// },

	//     getReviewAnalysis: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     getCategories: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     addNewCategory: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     delFullCategory: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     editFullCategory: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     addCategory: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     delCategory: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     getSentimentReview: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     getDatewiseSentimentHistogram: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getGoogleLocations: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getAllLocationsHistogram: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     fetchedLocationsHistogram: function (data, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     downloadInvoice: function (invoiceId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     listInvoices: function (profileId, limit, callback) {

	//         var token = cookie.readCookie("lctoken");
	//     },

	//     deleteSubscription: function (profileId, callback) {

	//         var token = cookie.readCookie("lctoken");
	//     },

	//     cancelSubscription: function (profileId, callback) {

	//         var token = cookie.readCookie("lctoken");
	//     },

	//     disableAccount: function (data, callback) {

	//         var token = cookie.readCookie("lctoken");
	//     },

	//     logout: function (token, callback) {
	//     },

	//     updatePaymentOwner: function (profileId, userId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getPaymentDetails: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getProfileLocationCount: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getHostPage: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	resetUserPassword: function (profileId, userId, urlName, callback) {
		let data = {
			profileId: profileId,
			userId: userId,
			domainName: urlName,
		};
		axios
			.post(config.server + "/resetPasswordRequestOwner", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getRoleDetails: function (profileId, roleId, callback) {
		axios
			.get(
				config.server +
				"/getRoleDetails?profileId=" +
				profileId +
				"&roleId=" +
				roleId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	assignUserstoRole: function (data, callback) {
		axios
			.post(config.server + "/updateProfileUserRole", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getUserDetails: function (profileId, userId, domain, callback) {
		let data = {
			profileId: profileId,
			userId: userId,
			domainName: domain,
		};
		axios
			.post(config.server + "/getUserDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getRoleUsers: function (profileId, role, callback) {
		axios
			.get(
				config.server +
				"/getRoleUsers?profileId=" +
				profileId +
				"&roleName=" +
				role,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteRole: function (profileId, roleId, callback) {
		axios
			.get(
				config.server +
				"/deleteRole?profileId=" +
				profileId +
				"&roleId=" +
				roleId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getRoles: function (profileId, page, size, searchTerm, callback) {
		var url =
			"/getRoles?profileId=" + profileId + "&from=" + page + "&size=" + size;
		if (searchTerm) {
			url += "&searchTerm=" + searchTerm;
		}
		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	createRole: function (data, callback) {
		axios
			.post(config.server + "/createRole", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createReport: function (data, callback) {
		axios
			.post(config.server + "/saveReportConfiguration", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getPaymentUrl: function (profileId, callback) {
		axios
			.get(config.server + "/getPaymentUrl?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	revertEdits: function (docId, callback) {
		axios
			.get(config.server + "/revertEdits?docId=" + docId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationUpdateHistoryDiff: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/getLocationUpdateHistoryDiff?profileId=" +
				profileId +
				"&locationId=" +
				locationId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getCategoryList: function (data, callback) {
		axios
			.post(config.server + "/getCategoryList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCategoryEditList: function (data, callback) {
		axios
			.post(config.server + "/getAllCategories", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	editLocation: function (data, callback) {
		axios
			.post(config.server + "/editLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editAppleLocationDetails: function (data, callback) {
		axios
			.put(config.server + "/editAppleLocationDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editLocationDetails: function (data, callback) {
		axios
			.post(config.server + "/editLocationDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFacebookInsightsHistogram: function (data, callback) {
		axios
			.post(config.server + "/getFacebookInsightsHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFacebookReviewHistogram: function (data, callback) {
		axios
			.post(config.server + "/getFacebookReviewHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	fetchFacebookData: function (profileId, pageId, callback) {
		axios
			.get(
				config.server +
				"/fetchFacebookData?profileId=" +
				profileId +
				"&pageId=" +
				pageId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	disableFacebookData: function (profileId, pageId, callback) {
		axios
			.get(
				config.server +
				"/deleteFacebookPage?profileId=" +
				profileId +
				"&pageId=" +
				pageId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updateProfileUsers: function (data, callback) {
		axios
			.post(config.server + "/updateProfileUsers", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteUserFromProfile: function (data, callback) {
		let accountId = cookie.readCookie("currentAccountId");
		if (accountId && accountId != null) {
			data.accountId = accountId;
		}
		axios
			.post(config.server + "/deleteUserFromProfile", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDomainDetails: async function (domainName, callback) {
		axios
			.get(config.server + "/getDomainDetails?domainName=" + domainName, {
				headers: { "Content-Type": "application/json" },
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	//     getFacebookReview: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	sendHelpEmail: function (data, callback) {
		axios
			.post(config.server + "/sendHelpEmail", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFacebookPages: function (profileId, fromPage, size, ishidden, callback) {
		axios
			.get(
				config.server +
				"/getFacebookPages?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size +
				"&isHidden=" +
				ishidden,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFacebookSync: function (profileId, pageId, callback) {
		axios
			.get(
				config.server +
				"/refreshFacebookPage?profileId=" +
				profileId +
				"&pageId=" +
				pageId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTripadvisorPages: function (profileId, fromPage, size, callback) {
		axios
			.get(
				config.server +
				"/getTripAdvisorPages?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getYelpPages: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     getBookingPages: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	//     getCellarpassPages: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	//     getFoursquareVenueTips: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	uploadLocationFilterTag: function (data, callback) {
		axios
			.post(config.server + "/uploadLocationFilterTag", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	compareDatesPerformance: function (data, callback) {
		axios
			.post(config.server + "/compareDatesPerformance", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocations: function (data, callback) {
		axios
			.post(config.server + "/getLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getGmbLocations: function (data, callback) {
		axios
			.post(config.server + "/getGmbLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getReviewSuggestionFilter: function (params, callback) {
		axios
			.get(config.server + "/getReviewSuggestionFilter", {
				headers: generateHeaderWithToken(),
				params: params,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationFilter: function (data, callback) {
		axios
			.post(config.server + "/getLocationFilter", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationsByAccounts: function (data, callback) {
		axios
			.post(config.server + "/getLocationsByAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteReplyTemplate: function (templateId, profileId, callback) {
		axios
			.get(
				config.server +
				"/deleteReplyTemplate?replyTemplateId=" +
				templateId +
				"&profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	editReplyTemplate: function (data, callback) {
		axios
			.post(config.server + "/editReplyTemplate", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGeneratedReply: function (data, callback) {
		axios
			.post(config.server + "/getGeneratedReply", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplyTemplate: function (data, callback) {
		axios
			.post(config.server + "/getReplyTemplates", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	createReplyTemplate: function (data, callback) {
		axios
			.post(config.server + "/createReplyTemplate", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	sendReplyForApproval: function (data, callback) {
		axios
			.post(config.server + "/sendReplyForApproval", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getFoursquareManagedVenues: function (profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	getUserToken: function (userId, domainName, callback) {
		let data = {
			userId: userId,
			domainName: domainName,
		};
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/loginAsUser", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFacebookAuthUrl: function (profileId, urlName, callback) {
		axios
			.get(
				config.server +
				"/getFacebookAuthUrl?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFoursquareAuthUrl: function (profileId, urlName, callback) {
		axios
			.get(
				config.server +
				"/getFoursquareAuthUrl?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getTopLocations: function (data, callback) {
		axios
			.post(config.server + "/getTopLocationsReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getUsageInfo: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getUsageInfo", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	checkAdmin: function (domain, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.get(config.server + "/checkAdminAccess?domainName=" + domain, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteProfile: function (profileId, domain, callback) {
		axios
			.get(
				config.server +
				"/deleteProfile?profileId=" +
				profileId +
				"&domainName=" +
				domain,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteSentReply: function (data, callback) {
		axios
			.post(config.server + "/deleteSentReply", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getNotes: function (data, callback) {
		axios
			.post(config.server + "/getNotes", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     deleteNote: function (replyId, noteId, profileId, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },

	createNote: function (data, callback) {
		axios
			.post(config.server + "/createNote", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	sendreplyFromOutbox: function (data, callback) {
		axios
			.post(config.server + "/sendReplyFromOutbox", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplySentDocs: function (data, callback) {
		axios
			.post(config.server + "/getReplySentDocs", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	moveReplyToOutbox: function (data, callback) {
		axios
			.post(config.server + "/moveReplyToOutbox", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplyOutboxDocs: function (data, callback) {
		axios
			.post(config.server + "/getReplyOutboxDocs", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReply: function (data, callback) {
		axios
			.post(config.server + "/deleteReply", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	sendReply: function (data, callback) {
		axios
			.post(config.server + "/sendReply", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplyApprovalDocs: function (data, callback) {
		axios
			.post(config.server + "/getReplyApprovalDocs", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getEditors: function (profileId, callback) {
		axios
			.get(config.server + "/getEditors?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getProfileSettings: function (profileId, callback) {
		axios
			.get(config.server + "/getProfileSettings?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveProfileSettings: function (data, callback) {
		axios
			.post(config.server + "/saveProfileSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationSummaryHistogram: function (data, callback) {
		axios
			.post(config.server + "/getLocationSummaryHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSentimentAnalysisScan: function (data, callback) {
		axios
			.post(config.server + "/getHistoricSentimentAnalysisStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	runSentimentAnalysisScan: function (data, callback) {
		axios
			.post(config.server + "/performHistoricSentimentsAnalysis", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	compareLocationsHistogram: function (data, callback) {
		axios
			.post(config.server + "/compareLocationsHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getFilterTags: function (data, callback) {
		axios
			.post(config.server + "/getFilterTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	saveFilterTag: function (tagObject, callback) {
		axios
			.post(config.server + "/saveFilterTag", tagObject, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updateEmail: function (data, callback) {
		axios
			.post(config.server + "/updateEmailForProfile", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateReadReview: function (data, callback) {
		axios
			.post(config.server + "/updateReadReview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDraftReview: function (reviewDocId, date, source, callback) {
		axios
			.get(
				config.server +
				"/getReview?reviewDocId=" +
				reviewDocId +
				"&date=" +
				date +
				"&source=" +
				source,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUnansweredReviews: function (data, callback) {
		axios
			.post(config.server + "/getAwaitingResponseReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDrafts: function (data, callback) {
		axios
			.post(config.server + "/getReviewReplyDrafts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getBubbleCount: function (data, callback) {
		axios
			.post(config.server + "/getReviewsTabBubbleCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveDraft: function (data, callback) {
		axios
			.post(config.server + "/saveReplyAsDraft", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewsCount: function (data, callback) {
		axios
			.post(config.server + "/getReviewsCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewResponseOverview: function (data, callback) {
		axios
			.post(config.server + "/getReviewResponseOverview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationTags: function (data, callback) {
		axios
			.post(config.server + "/getLocationTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	reviewTreelist: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");

		axios
			.post(config.server + "/getReviewsSummary", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	downloadTreelistExcel: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getReviewsSummaryCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	adminPasswordReset: function (userDetails, callback) {
		axios
			.post(config.server + "/resetPasswordAdmin", userDetails, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	resetPassword: function (userDetails, callback) {
		axios
			.post(config.server + "/resetPassword", userDetails, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	resetPasswordRequest: function (userId, urlName, callback) {
		let data = {
			userId: userId,
			domainName: urlName,
		};
		axios
			.post(config.server + "/resetPasswordRequest", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getDataFetchStatus: function (profileId, callback) {
		axios
			.get(config.server + "/getDataFetchingStatus?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getProfileDetails: function (profileId, domainName, callback) {
		axios
			.get(
				config.server +
				`/getProfileUserDetails?profileId=${profileId}&domainName=${domainName}`,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getDataStatus: function (profileId, callback) {
		axios
			.get(config.server + "/getDataStatus?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	enableAccount: function (data, callback) {
		axios
			.get(
				config.server +
				"/enableAccount?profileId=" +
				data.profileId +
				"&accountId=" +
				data.accountId +
				"&domainName=" +
				data.domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getProfiles: function (userId, callback) {
		// if (userId) {
		// 	token = userId;
		// }

		axios
			.get(config.server + "/getProfiles", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfilesDetails: function (data, callback) {
		axios
			.post(config.server + "/getProfileDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfilesV2: function (data, callback) {
		axios
			.post(config.server + "/getProfilesV2", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPaginatedPortfolios: function (data, callback) {
		axios
			.post(config.server + "/getPaginatedPortfolios", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	addProfile: function (data, callback) {

		axios
			.post(config.server + "/createProfile/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	inviteUser: function (data, token, callback) {
		let accountId = cookie.readCookie("currentAccountId");
		if (accountId && accountId != null) {
			data.accountId = accountId;
		}
		axios
			.post(config.server + "/inviteUser/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	// playStoreAuth: function(profileId,urlName,clientId,clientSecret,packageName,callback){
	playStoreAuth: function (data, callback) {
		var profileId = data.profileId;
		var clientId = data.clientId;
		var clientSecret = data.clientSecret;
		var packageName = data.packageName;
		var urlName = data.urlName;

		axios
			.get(
				config.server +
				"/playStoreAuth?profileId=" +
				profileId +
				"&domainName=" +
				urlName +
				"&clientId=" +
				clientId +
				"&clientSecret=" +
				clientSecret +
				"&packageName=" +
				packageName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	authoriseAccount: function (profileId, token, urlName, callback) {
		axios
			.get(
				config.server +
				"/mbAuth/?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	authoriseAppleAccount: function (profileId, urlName, callback) {
		var adminToken = cookie.readCookie("superuser");
		let headers = {
			Token: cookie.readCookie("lctoken"),
			"Content-Type": "application/x-www-form-urlencoded",
		};

		if (adminToken) {
			headers["AdminToken"] = adminToken;
		}
		axios
			.get(
				config.server +
				"/getAppleAuthRequestUrl/?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: headers,
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	//     downloadPdf: function (url, callback) {
	//         console.log("utilsConfig", utilsConfig.server, url)
	//     },

	login: function (userObject, callback) {

		axios
			.post(config.server + "/login/", userObject)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	signup: function (userObject, callback) {

		axios
			.post(config.server + "/signup/", userObject)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	//     getReviewsWorldCloud: function (data, callback) {
	//         var TOKEN = cookie.readCookie("lctoken");
	//     },

	getLocationInsightMetricCount: function (data, callback) {
		var test = JSON.parse(JSON.stringify(data));
		axios
			.post(config.server + "/getLocationInsightMetricCount/", test, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationPerformanceSummaryList: function (data, callback) {
		axios
			.post(config.server + "/getLocationPerformanceSummaryList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllLocationPerformanceSummaryList: function (data, callback) {
		axios
			.post(config.server + "/getAllLocationPerformanceSummaryList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationInsightHistogram: function (data, callback) {
		var test = JSON.parse(JSON.stringify(data));
		axios
			.post(config.server + "/getLocationInsightHistogram/", test, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationInsight: function (data, callback) {
		var test = JSON.parse(JSON.stringify(data));
		axios
			.post(config.server + "/getLocationInsight/", test, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationStates: function (data, callback) {
		axios
			.post(config.server + "/getLocationStates/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getReviewsTreemap: function (data, callback) {
		axios
			.post(config.server + "/getReviewsTreemap/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	searchReviews: function (data, callback) {
		axios
			.post(config.server + "/searchReviews/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewSuggestions: function (data, callback) {
		var profileId = data.profileId;
		var masterLocationFilter = data.masterLocationFilter;
		var url =
			"/getReviewSuggestions?profileId=" +
			profileId +
			"&masterLocationFilter=" +
			masterLocationFilter;
		var country = data.country || "";
		var area = data.area || "";
		var countries = data.countries || "";
		var apple = data.apple || null;


		if (countries) {
			url = url + "&country=" + countries;
		}
		// if(area){
		//     var locality = data.locality||"";
		//     url = url + '&locality='+locality;
		// }

		if (country) {
			url = url + "&country=" + country;
			var area = data.area || "";
		}
		if (area) {
			url = url + "&area=" + area;
			var locality = data.locality || "";
			url = url + "&locality=" + locality;
		}
		if (apple != null) {
			url = url + "&appleLocation=true"
		}

		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getAggregatedRatingCount: function (data, callback) {
		axios
			.post(config.server + "/getAggregatedRatingCount/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationRatings: function (data, callback) {
		axios
			.post(config.server + "/getLocationRatings/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationReviewSummaryList: function (data, callback) {
		axios
			.post(config.server + "/getLocationReviewSummaryList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllLocationReviewSummaryList: function (data, callback) {
		axios
			.post(config.server + "/getAllLocationReviewSummaryList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGridOverview: function (data, callback) {
		axios
			.post(config.server + "/getGridOverview/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPerformanceOverview: function (data, callback) {
		axios
			.post(config.server + "/getPerformanceOverview/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPerformanceSummaryReport: function (data, callback) {
		axios
			.post(config.server + "/getPerformanceSummaryReport/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllPerformanceSummaryReport: function (data, callback) {
		axios
			.post(config.server + "/getAllPerformanceSummaryReport/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getEnergyOverview: function (data, callback) {
		axios
			.post(config.server + "/getEnergyOverview/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getReviewHistogram: function (data, callback) {
		axios
			.post(config.server + "/getReviewHistogram/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getResponseHistogram: function (data, callback) {
		axios
			.post(config.server + "/getResponseHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadReviewLocation: function (data, callback) {
		axios
			.post(config.server + "/getReviewHistogramCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviews: function (data, callback) {
		axios
			.post(config.server + "/getReviews/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getZomatoReviews: function (data, callback) {
	//         var TOKEN = cookie.readCookie("lctoken");
	//     },

	postReply: function (data, callback) {
		axios
			.post(config.server + "/postReply/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getInboxReplies: function (
		reviewDocId,
		replyStatus,
		profileId,
		locId,
		callback,
	) {
		axios
			.get(
				config.server +
				"/getInboxReplies?reviewDocId=" +
				reviewDocId +
				"&replyStatus=" +
				replyStatus +
				"&profileId=" +
				profileId +
				"&locationId=" +
				locId +
				"&masterLocationFilter=" +
				localStorage.getItem("masterLocationFilter"),
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplies: function (reviewDocId, replyStatus, profileId, callback) {
		axios
			.get(
				config.server +
				"/getReplies?reviewDocId=" +
				reviewDocId +
				"&replyStatus=" +
				replyStatus +
				"&profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	searchWorkspace: function (domainName, emailId, callback) {
		axios
			.get(
				config.server +
				"/requestWorkspaceUserAccess?domainName=" +
				domainName +
				"&workspaceOwnerId=" +
				emailId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createWorkSpace: function (data, callback) {
		axios
			.post(config.server + "/createNewWorkspace", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	searchWorkspaceName: function (accountName, callback) {
		axios
			.get(config.server + "/validateWorkspace?accountName=" + accountName, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getOrganisations: function (
		profileId,
		listAllAccounts,
		fromPage,
		size,
		callback,
	) {
		var url =
			config.server +
			"/getOrganizations?profileId=" +
			profileId +
			"&listAllAccounts=" +
			listAllAccounts;
		if (fromPage !== undefined && size) {
			url += "&from=" + fromPage + "&size=" + size;
		}
		axios
			.get(url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getOrganizationFilter: function (profileId, callback, from, size, search) {
		var url = config.server + "/getOrganizationFilter?profileId=" + profileId;
		if (from !== undefined && size) {
			url += "&from=" + from + "&size=" + size;
		}
		if (search) {
			url += "&searchTerm=" + encodeURIComponent(search);
		}
		axios
			.get(url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSearchOrganisations: function (
		profileId,
		listAllAccounts,
		fromPage,
		size,
		serach,
		callback,
	) {
		var url =
			config.server +
			"/getOrganizations?profileId=" +
			profileId +
			"&listAllAccounts=" +
			listAllAccounts +
			"&searchTerm=" +
			serach;
		if (fromPage !== undefined && size) {
			url += "&from=" + fromPage + "&size=" + size;
		}
		axios
			.get(url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	listGooglePlayAccounts: function (data, callback) {
		axios
			.post(config.server + "/listGooglePlayAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	listAppStoreAccounts: function (data, callback) {
		axios
			.post(config.server + "/listAppStoreAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateGooglePlayAccount: function (data, callback) {
		axios
			.post(config.server + "/activateGooglePlayAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateAppStoreAccount: function (data, callback) {
		axios
			.post(config.server + "/activateAppStoreAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateAppleAccounts: function (data, callback) {
		axios
			.post(config.server + "/activateAppleAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateAppleLocation: function (data, callback) {
		axios
			.post(config.server + "/activateAppleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editAppleAccount: function (data, callback) {
		axios
			.post(config.server + "/editAppleMapsAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAppleAccount: function (data, callback) {
		axios
			.post(config.server + "/updateAppleMapsAccountStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkPublishLocations: function (data, callback) {
		axios
			.post(config.server + "/bulkPublishLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAppleLocation: function (data, callback) {
		axios
			.post(config.server + "/deleteAppleMapsLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAppleAccount: function (data, callback) {
		axios
			.post(config.server + "/deleteAppleMapsAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	listAppleMapsAccount: function (data, callback) {
		axios
			// .post(config.server + '/getAppleMapsAccounts', data, {
			.post(config.server + "/getBusinessAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleLocations: function (data, callback) {
		axios
			.post(config.server + "/getAppleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleBusinessLocations: function (data, callback) {
		axios
			.post(config.server + "/getAppleBusinessConnectLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	searchAppleMapsAccount: function (data, callback) {
		axios
			.post(config.server + "/searchAppleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshAppleAccount: function (data, callback) {
		axios
			.post(config.server + "/refreshAppleAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createBrandAsset: function (data, callback) {
		axios
			.post(config.server + "/createBrandAsset", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAppleBrands: function (data, callback) {
		axios
			.put(config.server + "/updateAppleBrands", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateImportedLocations: function (data, callback) {
		axios
			.post(config.server + "/updateImportedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadAppleImages: function (data, callback) {
		axios
			.post(config.server + "/uploadAppleImages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	publishAppleLocation: function (data, callback) {
		axios
			.post(config.server + "/publishAppleLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAppleAccounts: function (data, callback) {
		axios
			.post(config.server + "/updateAppleAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getActivatedPlayAccounts: function (profileId, callback) {
		var url =
			config.server + "/getActivatedPlayAccounts?profileId=" + profileId;
		// if (fromPage !== undefined && size) {
		//     url += "&from=" + fromPage + "&size=" + size;
		// }
		axios
			.get(url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUsersForProfile: function (data, callback) {
		//  var url = "/getUsersForProfile", data;
		// if (searchTerm) { url += "&searchTerm=" + searchTerm }
		axios
			.post(config.server + "/getUsersForProfile", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	editRole: function (data, callback) {
		axios
			.post(config.server + "/editRole", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTripadvisorReviewComments: function (data, callback) {
		axios
			.post(config.server + "/uploadTripAdvisorPages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewsCsv: function (data, callback) {
		axios
			.post(config.server + "/getReviewsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getOpenReviewsCsv: function (data, callback) {
		axios
			.post(config.server + "/getOpenReviewsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getYelpTsv: function (data, callback) {
		axios
			.post(config.server + "/uploadYelpPages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	UploadCsvReports: function (data, callback) {
		// var token = cookie.readCookie("lctoken");
		axios
			.post(config.server + "/uploadBulkRealTimeReport", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPhotoLocation: function (data, callback) {
		// var token = cookie.readCookie("superuser") || cookie.readCookie("lctoken");
		axios
			.post(config.server + "/getLocationsPhotoUrls", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createPlan: function (data, callback) {
		axios
			.post(config.server + "/createPlan", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addWorkspaceProfile: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/addWorkspaceProfiles", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addWorkspaceOwner: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/addWorkspaceOwner", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteWorkSpaceProfile: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/deleteProfileWorkspace", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCustomerPhotoLocation: function (data, callback) {
		// var token = cookie.readCookie("superuser")||cookie.readCookie("lctoken");
		data["userId"] = cookie.readCookie("userId");
		axios
			.post(config.server + "/getLocationsCustomersPhotoUrls", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFetcherHealthData: function (data, callback) {
		axios
			.post(config.server + "/fetcherHealthData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationInsightHistogramCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationInsightHistogramCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalActionConversionHistogram: function (data, callback) {
		var test = JSON.parse(JSON.stringify(data));

		axios
			.post(config.server + "/getLocalActionConversionHistogram/", test, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	hideAuthorisedAccount: function (data, callback) {
		axios
			.post(config.server + "/hideAuthorisedAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	hideFacebookAccount: function (data, callback) {
		axios
			.post(config.server + "/hideFacebookAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalActionHistogramCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocalActionConversionHistogramCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationIdCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationIdCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadFoodMenu: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/downloadFoodMenu/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadLocationHealth: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/downloadLocationshealthScore/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadAllListing: function (data, callback) {
		axios
			.post(config.server + "/downloadAllListing/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadAppleLocations: function (data, callback) {
		axios
			.post(config.server + "/downloadAppleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationService: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/downloadLocationServices/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadMasterLocationCsv: function (data, callback) {
		axios
			.post(config.server + "/uploadMasterLocationCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAssignedNotes: function (data, callback) {
		axios
			.post(config.server + "/getAssignedNotes", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllReviewTags: function (data, callback) {
		axios
			.post(config.server + "/getAllReviewTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllReviewTagsDownload: function (data, callback) {
		axios
			.post(config.server + "/getAllReviewTagsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllReviewData: function (data, callback) {
		axios
			.post(config.server + "/getAllReviewData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteINote: function (profileId, noteid, date, callback) {
		axios
			.get(
				config.server +
				"/deleteNote?profileId=" +
				profileId +
				"&noteId=" +
				noteid +
				"&date=" +
				date,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	revokeUserTokenPost: function (data, callback) {
		axios
			.post(
				config.server + "/revokeUserToken",
				data,
				{ headers: generateHeaderWithToken() },
			)
			.then((resp) => { callback(null, resp.data); })
			.catch((err) => { callback(err.response, null); });
	},
	getProfileTokens: function (data, callback) {
		axios
			.post(
				config.server + "/getProfileTokens",
				data,
				{ headers: generateHeaderWithToken() },
			)
			.then((resp) => { callback(null, resp.data); })
			.catch((err) => { callback(err.response, null); });
	},
	createApiKey: function (data, callback) {
		axios
			.post(
				config.server + "/createUserToken",
				data,
				{ headers: generateHeaderWithToken() },
			)
			.then((resp) => { callback(null, resp.data); })
			.catch((err) => { callback(err.response, null); });
	},
	createUserToken: function (userId, callback) {
		axios
			.get(
				config.server +
				"/createUserToken?userId=" +
				userId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	revokeUserToken: function (userId, callback) {
		axios
			.get(
				config.server +
				"/revokeUserToken?userId=" +
				userId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateNote: function (data, callback) {
		axios
			.post(config.server + "/updateNote", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	unassignNotes: function (profileId, reviewDocId, date, callback) {
		axios
			.get(
				config.server +
				"/unassignNotes?profileId=" +
				profileId +
				"&reviewDocId=" +
				reviewDocId +
				"&date=" +
				date,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadCitationData: function (data, callback) {
		axios
			.post(config.server + "/uploadCitationData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCitationData: function (profileId, type, callback) {
		axios
			.get(
				config.server +
				"/getCitationData?profileId=" +
				profileId +
				"&indexType=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createLocalPost: function (data, callback) {
		axios
			.post(config.server + "/createLocalPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getMasterDataStatus: function (profileId, callback) {
		axios
			.get(config.server + "/getMasterDataStatus?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPosts: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/getLocalPosts?profileId=" +
				profileId +
				"&locationId=" +
				locationId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteLocalPost: function (data, callback) {
		axios
			.delete(config.server + "/deleteLocalPost", {
				headers: generateHeaderWithToken(),
				data,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadPostImages: function (data, callback) {
		axios
			.post(config.server + "/uploadPostImages", data, {
				headers: generateHeaderWithToken(),
				cache: false,
				processData: false,
				contentType: false,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getScheduleLocalPost: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/getScheduledPosts?profileId=" +
				profileId +
				"&locationId=" +
				locationId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateScheduledPost: function (data, callback) {
		axios
			.post(config.server + "/updateScheduledPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateLocalPost: function (data, callback) {
		axios
			.post(config.server + "/updateLocalPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteScheduledPost: function (data, callback) {
		axios
			.delete(config.server + "/deleteScheduledPost", {
				headers: generateHeaderWithToken(),
				data: data,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadlocalpost: function (data, callback) {
		axios
			.post(config.server + "/upload/localPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostHistory: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPostHistory: function (data, callback) {
		axios
			.post(config.server + "/getPostHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getMasterLocationDetails: function (data, callback) {
		axios
			.post(config.server + "/getMasterLocationDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getLawyersPages: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	getSources: function (profileId, callback) {
		axios
			.get(config.server + "/getSources?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSourcesLocations: function (profileId, callback) {
		axios
			.get(
				config.server +
				"/getSources?profileId=" +
				profileId +
				"&locationSources=true",
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSearchSources: function (profileId, search, callback) {
		axios
			.get(
				config.server +
				"/getSources?profileId=" +
				profileId +
				"&searchTerm=" +
				search,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getRatemdsPages: function (profileId, fromPage, size, callback) {
	//         var token = cookie.readCookie("lctoken");
	//     },
	getAttributeList: function (data, callback) {
		axios
			.post(config.server + "/getAttributeList", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPupprenderPages: function (profileId, fromPage, size, type, callback) {
		axios
			.get(
				config.server +
				"/getPupprenderPages?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size +
				"&reviewType=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadLocationFilterTag: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadLocationFilterTag", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationDetailsCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationDetailsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleMapsData: function (data, callback) {
		axios
			.post(config.server + "/getAppleMapsData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getAllAppleLocations: function (data, callback) {
		axios
			.post(config.server + "/getAllAppleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllFacebookLocations: function (data, callback) {
		axios
			.post(config.server + "/getAllFacebookLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFacebookLocations: function (data, callback) {
		axios
			.post(config.server + "/getFacebookLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTrustpilotLocations: function (data, callback) {
		axios
			.post(config.server + "/getTrustpilotLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGooglePlaystoreLocations: function (data, callback) {
		axios
			.post(config.server + "/getGooglePlaystoreLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleAppstoreLocations: function (data, callback) {
		axios
			.post(config.server + "/getAppleAppstoreLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDatashakeLocations: function (data, callback) {
		axios
			.post(config.server + "/getDatashakeLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleLocationAssets: function (data, callback) {
		axios
			.post(config.server + "/getAppleLocationAssets", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleLocationEditHistory: function (data, callback) {
		axios
			.post(config.server + "/getAppleLocationEditHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleAttributes: function (data, callback) {
		axios
			.post(config.server + "/getAppleAttributes", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleCategories: function (data, callback) {
		axios
			.post(config.server + "/getAppleCategories", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllLocations: function (data, callback) {
		axios
			.post(config.server + '/getAllLocations', data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	viewFilterTag: function (
		filterTagId,
		groupType,
		profileId,
		masterLocationFilter,
		callback,
	) {
		axios
			.get(
				config.server +
				"/viewFilterTag?filterTagId=" +
				filterTagId +
				"&groupType=" +
				groupType +
				"&profileId=" +
				profileId +
				"&masterLocationFilter=" +
				masterLocationFilter,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editLocationFilterTag: function (data, callback) {
		axios
			.post(config.server + "/editLocationFilterTag", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadLogoImages: function (data, callback) {
		axios
			.post(config.server + "/uploadLogoImages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPlanDetails: function (callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.get(config.server + "/getPlanDetails", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deletePlan: function (profileId, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.get(config.server + "/deletePlan?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editPlanDetails: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/editPlanDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfilesAdmin: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getProfilesAdmin", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkspaceTable: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getWokspacesAdmin", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editProfileName: function (data, callback) {
		axios
			.post(config.server + "/editProfileName", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateWorkSpace: function (data, callback) {
		axios
			.post(config.server + "/editWorkspace", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateWorkspaceNotes: function (data, callback) {
		axios
			.post(config.server + "/updateWorkspaceNotes", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editBusinessTeamUsers: function (data, callback) {
		axios
			.post(config.server + "/editBusinessTeamUsers", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDomainName: function (callback) {
		axios
			.get(config.server + "/getAllDomainName", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshUsageInfo: function (callback) {
		axios
			.get(config.server + "/refreshUsageInfo", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshProfileLocation: function (data, callback) {
		axios
			.post(config.server + "/refreshProfileSummary", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	fetchLocationVerificationOptions: function (data, callback) {
		axios
			.post(config.server + "/fetchLocationVerificationOptions", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationVerify: function (data, callback) {
		axios
			.post(config.server + "/getLocationVerify", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationsCount: function (data, callback) {
		axios
			.post(config.server + "/getLocationsCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	completeLocationVerification: function (data, callback) {
		axios
			.post(config.server + "/completeLocationVerification", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	sendExternalNote: function (data, callback) {
		axios
			.post(config.server + "/createExternalNote", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteExternalNote: function (noteId, date, profileId, callback) {
		axios
			.get(
				config.server +
				"/deleteExternalNote?profileId=" +
				profileId +
				"&date=" +
				date +
				"&noteId=" +
				noteId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createLeftNavigationLink: function (data, callback) {
		axios
			.post(config.server + "/createLeftNavigationLink", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLeftNavigationLinks: function (profileId, domainName, callback) {
		axios
			.get(
				config.server +
				"/getLeftNavigationLinks?profileId=" +
				profileId +
				"&domainName=" +
				domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteLeftNavigationLinks: function (profileId, tabId, callback) {
		axios
			.get(
				config.server +
				"/deleteLeftNavigationLink?profileId=" +
				profileId +
				"&tabId=" +
				tabId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteCustomNavigationLinks: function (domainName, tabId, callback) {
		axios
			.get(
				config.server +
				"/deleteCustomDomainNavigation?domainName=" +
				domainName +
				"&tabId=" +
				tabId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editLeftNavigationLink: function (data, callback) {
		axios
			.post(config.server + "/editLeftNavigationLink", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getEntityTags: function (data, callback) {
		axios
			.post(config.server + "/getEntityTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addLocationContactDetails: function (data, callback) {
		axios
			.post(config.server + "/manipulateLocationContactDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshAppleLocation: function (data, callback) {
		axios
			.post(config.server + "/refreshAppleLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteLocationNote: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/deleteLocationNote?profileId=" +
				profileId +
				"&locationId=" +
				locationId +
				"&masterLocationFilter=" +
				localStorage.getItem("masterLocationFilter"),
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getQuestionAnswers: function (QuestionDocId, profileId, callback) {
		axios
			.get(
				config.server +
				"/getQuestionAnswers?questionDocId=" +
				QuestionDocId +
				"&profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	sendAnswerToQuestion: function (data, callback) {
		axios
			.post(config.server + "/sendAnswerToQuestion", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshLocation: function (data, callback) {
		axios
			.get(
				config.server +
				"/refreshLocation?locationId=" +
				data.locationId +
				"&accountId=" +
				data.accountId +
				"&profileId=" +
				data.profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadLocationNotes: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadLocationNotes", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadSocialMediaLinks: function (data, callback) {
		axios
			.post(config.server + "/uploadSocialMediaLinks", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationNotesUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationNotesUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadLocationImageLinks: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadLocationImageLinks", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	hideLocations: function (data, callback) {
		axios
			.post(config.server + "/hideLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	//     getpublicimage: function (data, callback) {
	//         var TOKEN = cookie.readCookie("lctoken");
	//     },
	setReplyContactMail: function (data, callback) {
		axios
			.post(config.server + "/setReplyContactMail", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationDetails: function (data, callback) {
		axios
			.get(
				config.server +
				"/getLocationDetails?locationId=" +
				data.locationId +
				"&profileId=" +
				data.profileId +
				"&source=" +
				data.source +
				"&masterLocationFilter=" +
				data.masterLocationFilter,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	googleLocationsSearch: function (data, callback) {
		axios
			.post(config.server + "/googleLocationsSearch", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createLocation: function (data, callback) {
		axios
			.post(config.server + "/createLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadGoogleLocationImageLinks: function (data, callback) {
		axios
			.post(config.server + "/uploadGoogleLocationImageLinks", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createLocationQuestion: function (data, callback) {
		axios
			.post(config.server + "/createLocationQuestion", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bookingAuth: function (profileId, urlName, callback) {
		axios
			.get(
				config.server +
				"/bookingAuth?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getIntegrationLocations: function (
		profileId,
		fromPage,
		size,
		type,
		callback,
	) {
		axios
			.get(
				config.server +
				"/getIntegrationLocations?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size +
				"&reviewType=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	zomatovalidation: function (id, callback) {
		axios
			.get("https://developers.zomato.com/api/v2.1/restaurant?res_id=" + id, {
				headers: {
					"user-key": "168df782864ab5de16cfdb1bc97a71c2",
					"Content-Type": "application/json",
				},
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationFilterTagCsv: function (
		profileId,
		masterLocation,
		domain,
		callback,
	) {
		axios
			.get(
				config.server +
				"/getLocationFilterTagCsv?profileId=" +
				profileId +
				"&masterLocationFilter=" +
				masterLocation +
				"&domainName=" +
				domain,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBookingLocations: function (profileId, fromPage, size, callback) {
		axios
			.get(
				config.server +
				"/getBookingLocations?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	enableBookingLocation: function (profileId, hotelId, callback) {
		axios
			.get(
				config.server +
				"/enableBookingLocation?profileId=" +
				profileId +
				"&hotelId=" +
				hotelId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	disableBookingLocation: function (profileId, hotelId, callback) {
		axios
			.get(
				config.server +
				"/disableBookingLocation?profileId=" +
				profileId +
				"&hotelId=" +
				hotelId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationAudits: function (data, callback) {
		axios
			.post(config.server + "/getLocationAudits", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfileAudits: function (data, callback) {
		axios
			.post(config.server + "/getProfileAudits", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getListingAudits: function (data, callback) {
		axios
			.post(config.server + "/getListingAudits", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getListingAuditSummary: function (data, callback) {
		axios
			.post(config.server + "/getListingAuditSummary", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getListingAuditHistogram: function (data, callback) {
		axios
			.post(config.server + "/getListingAuditHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	scheduleAutomaticWeeklySync: function (data, callback) {
		axios
			.post(config.server + "/scheduleAutomaticWeeklySync", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAutomaticWeeklySyncData: function (profileId, callback) {
		axios
			.get(
				config.server + "/getAutomaticWeeklySyncData?profileId=" + profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWebhosePages: function (data, callback) {
		axios
			.post(config.server + "/getWebhosePages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostInsightHistogram: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostInsightHistogram/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostAndInsightsCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostAndInsightsCsv/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostInsightCount: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostInsightCount/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	removeMasterLocation: function (profileId, callback) {
		axios
			.get(config.server + "/removeMasterLocation?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostAndInsightDetails: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostAndInsightDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostAnalysis: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostAnalysis", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAuditsCsv: function (data, callback) {
		axios
			.post(config.server + "/getAuditsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAudits: function (profileId, auditId, callback) {
		axios
			.get(
				config.server +
				"/deleteAudits?profileId=" +
				profileId +
				"&auditId=" +
				auditId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	trustPilotAuth: function (profileId, urlName, callback) {
		axios
			.get(
				config.server +
				"/trustPilotAuth?profileId=" +
				profileId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshTrustPilotAuth: function (profileId, businessId, callback) {
		axios
			.get(
				config.server +
				"/refreshTrustpilotBusinessUnit?profileId=" +
				profileId +
				"&businessUnitId=" +
				businessId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTrustPilotLocations: function (profileId, fromPage, size, callback) {
		axios
			.get(
				config.server +
				"/getTrustPilotLocations?profileId=" +
				profileId +
				"&from=" +
				fromPage +
				"&size=" +
				size,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	enableTrustPilotLocation: function (profileId, businessId, callback) {
		axios
			.get(
				config.server +
				"/enableTrustPilotLocation?profileId=" +
				profileId +
				"&businessUnitId=" +
				businessId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	disableTrustPilotLocation: function (profileId, businessId, callback) {
		axios
			.get(
				config.server +
				"/disableTrustPilotLocation?profileId=" +
				profileId +
				"&businessUnitId=" +
				businessId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostAndInsightDetailsCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostAndInsightDetailsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addReplyNames: function (data, callback) {
		axios
			.post(config.server + "/addLocationAlias", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplyNamesUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getReplyNamesUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadLocationAliases: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadLocationAliases", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateLocalPostStatus: function (profileId, callback) {
		axios
			.get(config.server + "/updateLocalPostStatus?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReplyNames: function (data, callback) {
		axios
			.post(config.server + "/deleteLocationAlias", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostCount: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addReviewStarReply: function (data, callback) {
		axios
			.post(config.server + "/addARTemplate", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadReviewStarReplies: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadARTemplates", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReviewStarReply: function (profileId, id, callback) {
		axios
			.get(
				config.server +
				"/deleteARTemplate?profileId=" +
				profileId +
				"&id=" +
				id,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewStarReplies: function (data, callback) {
		// axios.post(config.server + "/getAllARTemplates?profileId=" + data.profileId + "&from=" + data.from + "&size=" + data.size + "&searchText=" + data.searchText,
		axios
			.post(config.server + "/getAllARTemplates", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editReviewStarReply: function (data, callback) {
		axios
			.post(config.server + "/editARTemplate", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostStatusUpdateTime: function (profileId, callback) {
		axios
			.get(
				config.server + "/getLocalPostStatusUpdateTime?profileId=" + profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReplyNamesUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationAliasesUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadGoogleQA: function (data, callback) {
		axios
			.post(config.server + "/uploadGoogleQA", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleQAUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getGoogleQAUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFetchQueueStatus: function (data, callback) {
		axios
			.get(
				config.server +
				"/getFetchQueueStatus" +
				"?profileId=" +
				data.profileId +
				"&fetchType=" +
				data.fetchType,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleQAHistory: function (profileId, callback) {
		axios
			.get(config.server + "/getGoogleQAHistory" + "?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addARSettings: function (data, callback) {
		axios
			.post(config.server + "/addARSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addNewAIAgent: function (data, callback) {
		axios
			.post(config.server + "/addNewAIAgent", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAgent: function (data, callback) {
		axios
			.post(config.server + "/editAIAgent", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllARSettings: function (profileId, callback) {
		axios
			.get(config.server + "/getAllARSettings" + "?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllAIAgents: function (data, callback) {
		axios
			.post(config.server + "/getAllAIAgents", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAIAgent: function (data, callback) {
		axios
			.post(config.server + "/deleteAIAgent", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteARSettings: function (profileId, id, callback) {
		axios
			.get(
				config.server +
				"/deleteARSettings" +
				"?profileId=" +
				profileId +
				"&id=" +
				id,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editARSettings: function (data, callback) {
		axios
			.post(config.server + "/editARSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	validateAIAgent: function (data, callback) {
		axios
			.post(config.server + "/validateAIAgent", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	validateARSettings: function (data, callback) {
		axios
			.post(config.server + "/validateARSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	integrationsadd: function (data, callback) {
		axios
			.post(config.server + "/integrations/add", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addNav: function (data, callback) {
		axios
			.post(config.server + "/createCustomDomainNavigation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	integrationMonitor: function (data, callback) {
		axios
			.post(config.server + "/getAllIntegratedIndexResourcesReport", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllWorkspaces: function (data, callback) {
		axios
			.post(config.server + "/getAllProfilesOrWorkspaces", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSourceList: function (callback) {
		axios
			.get(config.server + "/getAllIndexedSources", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	integrationsread: function (domain, callback) {
		axios
			.get(config.server + "/integrations/read?domain=" + domain, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkplace: function (callback) {
		axios
			.get(config.server + "/getWorkspaces", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkplaceAccount: function (accountId, callback) {
		axios
			.get(config.server + "/getWorkspaces?accountId=" + accountId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkplaceUpdateTime: function (callback) {
		var adminToken = cookie.readCookie("superuser");
		let accountId = cookie.readCookie("currentAccountId");
		axios
			.get(config.server + "/updateWorkspaceLoginTime?accountId=" + accountId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllWorkspaceProfile: function (accountId, callback) {
		axios
			.get(config.server + "/getAllWorkspaceProfiles?accountId=" + accountId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkplaceUsers: function (data, callback) {
		axios
			.post(config.server + "/getAllWorkspaceUsers", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteUserFromProfile: function (data, callback) {
		let accountId = cookie.readCookie("currentAccountId");
		if (accountId && accountId != null) {
			data.accountId = accountId;
		}
		axios
			.post(config.server + "/deleteUserFromProfile", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	manageWorkspaceRequest: function (data, callback) {
		axios
			.post(config.server + "/manageUsersWorkspaceRequest", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPaymentMethod: function (data, callback) {
		axios
			.get(config.server + "/getWorkspaceCardDetails?accountId=" + data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getprofilesWorkspace: function (accountId, callback) {
		axios
			.post(config.server + "/getProfilesByWorkspace", accountId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPaymentHistory: function (accountId, callback) {
		axios
			.get(
				config.server +
				"/getWorkspacePaymentHistory?accountId=" +
				accountId +
				"&limit=10",
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPaymentHost: function (profileId, type, callback) {
		axios
			.get(
				config.server +
				"/getHostPagePayment?profileId=" +
				profileId +
				"&type=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	paymentDelete: function (profileId, callback) {
		axios
			.get(config.server + "/deleteCard?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCustomNav: function (domain, callback) {
		axios
			.get(config.server + "/getCustomDomainNavigations?domainName=" + domain, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	integrationsupdate: function (data, callback) {
		axios
			.post(config.server + "/integrations/update", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateCustomNav: function (data, callback) {
		axios
			.post(config.server + "/editCustomDomainNavigation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	integrationsdelete: function (domain, callback) {
		axios
			.delete(config.server + "/integrations/delete?domain =" + domain, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCategoryListCsv: function (data, callback) {
		axios
			.post(config.server + "/getCategoryListCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	requestDateRangeReviewClarity: function (data, callback) {
		axios
			.post(config.server + "/requestDateRangeReviewClarity", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewResponseHistogram: function (data, callback) {
		axios
			.post(config.server + "/getReviewResponseHistogram", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewClarityHistory: function (profileId, from, size, callback) {
		axios
			.get(
				config.server +
				"/getReviewClarityHistory" +
				"?profileId=" +
				profileId +
				"&from=" +
				from +
				"&size=" +
				size,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	ReviewClarityHistoryById: function (data, callback) {
		axios
			.post(config.server + "/getReviewClarityHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewClarityReviews: function (data, callback) {
		axios
			.post(config.server + "/getReviewClarityReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getIntegrationConnections: function (profileId, callback) {
		axios
			.get(
				config.server +
				"/getIntegrationConnections" +
				"?profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadReportConfiguration: function (profileId, callback) {
		axios
			.get(
				config.server +
				"/downloadReportConfiguration" +
				"?profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadFirstPartyReviewsCsv: function (data, callback) {
		axios
			.post(config.server + "/uploadFirstPartyReviewsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadReviewShakeUrls: function (data, callback) {
		axios
			.post(config.server + "/uploadReviewShakeUrls", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewShakePages: function (data, callback) {
		axios
			.post(config.server + "/getReviewShakePages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReviewShakeUrls: function (data, callback) {
		axios
			.post(config.server + "/deleteReviewShakeUrl", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editSentReply: function (data, callback) {
		axios
			.post(config.server + "/editSentReply", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	verifyUserEmail: function (data, callback) {
		axios
			.post(config.server + "/verifyUserEmail", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteProfileUser: function (data, callback) {
		axios
			.post(config.server + "/deleteProfileUsers", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	markReviewsDeleted: function (data, callback) {
		axios
			.post(config.server + "/markReviewsDeleted", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	refreshSingleReview: function (data, callback) {
		axios
			.post(config.server + "/refreshReview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createReviewAudit: function (data, callback) {
		axios
			.post(config.server + "/createReviewAudit", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewAuditStatus: function (data, callback) {
		axios
			.post(config.server + "/getReviewAuditStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadReviewShakeAppUrls: function (data, callback) {
		axios
			.post(config.server + "/uploadReviewShakeAppUrls", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadReviewShakeAppFileData: function (data, callback) {
		axios
			.post(config.server + "/uploadReviewShakeAppFileData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadLocalPostToSchedule: function (data, callback) {
		axios
			.post(config.server + "/uploadLocalPostToSchedule", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getScheduledLocalPostStatus: function (data, callback) {
		axios
			.post(config.server + "/getScheduledLocalPostStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostVerificationResults: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostVerificationResults", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostVerificationCounts: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostVerificationCounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllScheduledLocalPostUploads: function (data, callback) {
		axios
			.post(config.server + "/getAllScheduledLocalPostUploads", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editValidatedLocalPost: function (data, callback) {
		axios
			.post(config.server + "/editValidatedLocalPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteValidatedLocalPost: function (data, callback) {
		axios
			.post(config.server + "/deleteValidatedLocalPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	scheduleVerifiedLocalPosts: function (data, callback) {
		axios
			.post(config.server + "/scheduleVerifiedLocalPosts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getScheduledLocalPosts: function (data, callback) {
		axios
			.post(config.server + "/getScheduledLocalPosts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalPostSchedulingStatus: function (data, callback) {
		axios
			.post(config.server + "/getLocalPostSchedulingStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleSheetCreateStatus: function (data, callback) {
		axios
			.post(config.server + "/getGoogleSheetCreateStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationDetailsInGoogleSheets: function (data, callback) {
		axios
			.post(config.server + "/getLocationDetailsInGoogleSheets", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUpdateLocationDetails: function (data, callback) {
		axios
			.post(config.server + "/bulkUpdateLocationDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	unhideFacebookAccount: function (data, callback) {
		axios
			.post(config.server + "/unhideFacebookAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadWhitelabelImage: function (data, callback) {
		axios
			.post(config.server + "/uploadWhitelabelImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllGmbEditRequests: function (data, callback) {
		axios
			.post(config.server + "/getAllLocationEditRequests", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGmbEditResult: function (data, callback) {
		axios
			.post(config.server + "/getLocationEditResult", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCommentsCount: function (data, callback) {
		axios
			.post(config.server + "/getCommentsCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWordCount: function (data, callback) {
		axios
			.post(config.server + "/getWordCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadCompetitorUrls: function (data, callback) {
		axios
			.post(config.server + "/uploadCompetitorUrls", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTopCompetitors: function (data, callback) {
		axios
			.post(config.server + "/getTopCompetitors", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	closeReview: function (data, callback) {
		axios
			.post(config.server + "/updateClosedReview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	reopenClosedReview: function (data, callback) {
		axios
			.post(config.server + "/reopenReview", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewShakeReverseUrlLookUp: function (data, callback) {
		axios
			.post(config.server + "/getReviewShakeReverseUrlLookUp", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addCompetitorNames: function (data, callback) {
		axios
			.post(config.server + "/addCompetitorNames", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorNames: function (profileId, callback) {
		axios
			.get(config.server + "/getCompetitorNames?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadCompetitorImage: function (data, callback) {
		axios
			.post(config.server + "/uploadCompetitorImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editCompetitor: function (data, callback) {
		axios
			.post(config.server + "/editCompetitor", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteCompetitor: function (data, callback) {
		axios
			.post(config.server + "/deleteCompetitor", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTopCompetitorsReplyRatingCount: function (data, callback) {
		axios
			.post(config.server + "/getTopCompetitorsReplyRatingCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTopCompetitorsCommentsCount: function (data, callback) {
		axios
			.post(config.server + "/getTopCompetitorsCommentsCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTopCompetitorsWordsCount: function (data, callback) {
		axios
			.post(config.server + "/getTopCompetitorsWordCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	unMarkReviewsDeleted: function (data, callback) {
		axios
			.post(config.server + "/unMarkReviewsDeleted", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	reactiveSubscription: function (profileId, callback) {
		axios
			.get(config.server + "/reactiveSubscription?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorReviews: function (data, callback) {
		axios
			.post(config.server + "/getCompetitorReviews", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorReviewRating: function (data, callback) {
		axios
			.post(config.server + "/getCompetitorReviewRating", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorSources: function (profileId, callback) {
		axios
			.get(
				config.server +
				"/getSources?profileId=" +
				profileId +
				"&isCompetitor=" +
				true,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorLocations: function (data, callback) {
		axios
			.post(config.server + "/getCompetitorLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateCompetitorTags: function (data, callback) {
		axios
			.post(config.server + "/updateCompetitorTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	resyncReviewShakeAccount: function (data, callback) {
		axios
			.post(config.server + "/resyncReviewShakeAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getMailedReportDetails: function (data, callback) {
		axios
			.post(config.server + "/getMailedReportDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteBulkManagementHistory: function (data, callback) {
		axios
			.post(config.server + "/deleteBulkManagementHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadUserImage: function (data, callback) {
		axios
			.post(config.server + "/uploadUserImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUser: function (userId, callback) {
		var adminToken = cookie.readCookie("superuser");
		let data = { userId: userId };
		axios
			.post(config.server + "/getUser", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateProfileLandingPage: function (tabName, callback) {
		axios
			.get(config.server + "/updateProfileLandingPage?landingPage=" + tabName, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUserDetailsCsv: function (profileId, domain, callback) {
		axios
			.get(
				config.server +
				"/getUserDetailsCsv?profileId=" +
				profileId +
				"&domainName=" +
				domain,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUserSettings: function (domainName, callback) {
		axios
			.get(config.server + "/getUserSettings?domainName=" + domainName, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleLocationDetailsCsv: function (profileId, domain, type, callback) {
		axios
			.get(
				config.server +
				"/getGoogleLocationDetailsCsv?profileId=" +
				profileId +
				"&domainName=" +
				domain +
				"&isCompetitor=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationReviewSummary: function (data, callback) {
		axios
			.post(config.server + "/getLocationReviewSummary", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateProfileUserFilter: function (data, callback) {
		axios
			.post(config.server + "/updateProfileUserFilter", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCompetitorReviewsCsv: function (data, callback) {
		axios
			.post(config.server + "/getCompetitorReviewsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getReviewResponse: function (data, callback) {
		axios
			.post(config.server + "/getReviewResponse", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllReplyTemplates: function (data, callback) {
		axios
			.post(config.server + "/getAllReplyTemplates", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadCompetitorFileData: function (data, callback) {
		axios
			.post(config.server + "/uploadCompetitorFileData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createSnippet: function (data, callback) {
		axios
			.post(config.server + "/createSnippet", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateSnippet: function (data, callback) {
		axios
			.post(config.server + "/updateSnippet", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteSnippet: function (data, callback) {
		axios
			.post(config.server + "/deleteSnippet", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDataStudioConnector: function (profileId, type, callback) {
		axios
			.get(
				config.server +
				"/getDataStudioConnector?profileId=" +
				profileId +
				"&dataset=" +
				type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getScrapperData: function (data, callback) {
		axios
			.post(config.server + "/getScraperStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	fetchAuditData: function (data, callback) {
		axios
			.post(config.server + "/fetchAuditData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	auditDataFetchStatus: function (data, callback) {
		axios
			.post(config.server + "/auditDataFetchStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateScrapperData: function (data, callback) {
		axios
			.post(config.server + "/scrapWebsiteData", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editBackOfficeId: function (data, callback) {
		axios
			.post(config.server + "/editBackOfficeId", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllActiveLocationCount: function (data, callback) {
		axios
			.post(config.server + "/getAllActiveLocationCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUsageInfoDynamicSearch: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");

		axios
			.post(config.server + "/getUsageInfoDynamicSearch", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBillingLocationsCsv: function (data, callback) {
		axios
			.post(config.server + "/getBillingLocationsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	connectDataStudio: function (data, callback) {
		axios
			.post(config.server + "/connectDataStudio", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getDataStudioStatus: function (field, value, callback) {
		axios
			.get(config.server + "/getDataStudioStatus?" + field + "=" + value, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createTier: function (data, callback) {
		axios
			.post(config.server + "/createTier", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTiers: function (field, value, callback) {
		axios
			.get(config.server + "/getTiers?" + field + "=" + value, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteTier: function (id, callback) {
		axios
			.get(config.server + "/deleteTier?tierId=" + id, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	assignTier: function (data, callback) {
		axios
			.post(config.server + "/assignTier", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationStatusCount: function (data, callback) {
		axios
			.post(config.server + "/getLocationStatusCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationGroups: function (data, callback) {
		axios
			.post(config.server + "/getLocationGroups", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationAttributesCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationAttributesCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getConversionRates: function (data, callback) {
		axios
			.post(config.server + "/getConversionRates", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getConversionRatesCSV: function (data, callback) {
		axios
			.post(config.server + "/getConversionRatesCSV", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	blackListUsers: function (userId, isBlackListed, callback) {
		axios
			.get(
				config.server +
				"/blackListUsers?userId=" +
				userId +
				"&isBlackListed=" +
				isBlackListed,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteUserAccount: function (userId, domainName, callback) {
		axios
			.get(
				config.server +
				"/deleteUserAccount?userId=" +
				userId +
				"&domainName=" +
				domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createPortfolio: function (data, callback) {
		axios
			.post(config.server + "/createPortfolio/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getPortfolios: function (callback) {

		axios
			.get(config.server + "/getPortfolios", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deletePortfolio: function (portfolioId, callback) {
		axios
			.delete(config.server + "/deletePortfolio?portfolioId=" + portfolioId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getPortfolioUsers: function (portfolioId, fromPage, size, callback) {
		var url =
			"/getPortfolioUsers?portfolioId=" +
			portfolioId +
			"&from=" +
			fromPage +
			"&size=" +
			size;

		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	blackListUsers: function (userId, isBlackListed, callback) {
		axios
			.get(
				config.server +
				"/blackListUsers?userId=" +
				userId +
				"&isBlackListed=" +
				isBlackListed,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPortfolioProfiles: function (portfolioId, callback) {
		var url = "/getPortfolioProfiles?portfolioId=" + portfolioId;

		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	assignProfilesToPortfolio: function (data, callback) {
		axios
			.post(config.server + "/assignProfilesToPortfolio", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deletePortfolioProfile: function (profileId, portfolioId, callback) {
		axios
			.get(
				config.server +
				"/deletePortfolioProfile?portfolioId=" +
				portfolioId +
				"&profileId=" +
				profileId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllUserCreatedRoles: function (profileId, callback) {
		var url = "/getAllUserCreatedRoles?profileId=" + profileId;

		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	invitePortfolioUser: function (data, callback) {
		axios
			.post(config.server + "/invitePortfolioUser", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	removePortfolioUser: function (portfolioId, userId, callback) {
		var url =
			"/removePortfolioUser?portfolioId=" + portfolioId + "&userId=" + userId;

		axios
			.get(config.server + url, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteUserAccount: function (userId, domainName, callback) {
		axios
			.get(
				config.server +
				"/deleteUserAccount?userId=" +
				userId +
				"&domainName=" +
				domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getPortfolioUserDetails: function (userId, portfolioId, callback) {
		axios
			.get(
				config.server +
				"/getPortfolioUserDetails?userId=" +
				userId +
				"&portfolioId=" +
				portfolioId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	assignUsersToProfiles: function (data, callback) {
		axios
			.post(config.server + "/assignUsersToProfiles", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editPortfolio: function (data, callback) {
		axios
			.post(config.server + "/editPortfolio", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	uploadPortfolioImage: function (data, callback) {
		axios
			.post(config.server + "/uploadPortfolioImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveUserSettings: function (data, callback) {
		axios
			.post(config.server + "/saveUserSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateProfileLoginTime: function (data, callback) {
		axios
			.get(config.server + "/updateProfileLoginTime?profileId=" + data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPortfolioProfileList: function (data, callback) {
		// var TOKEN = cookie.readCookie("lctoken");
		// axios.get(config.server + "/getPortfolioProfileList", data,
		//     {
		//         headers: {
		//             "Token": TOKEN,
		//             "Content-Type": "application/json"
		//         }
		//     })
		//     .then((resp) => {
		//         callback(null, resp.data)
		//     })
		//     .catch((err) => {
		//         callback(err.response, null)
		//     })
		// if (data) {
		// 	token = data;
		// }

		axios
			.get(config.server + "/getPortfolioProfileList", {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updatePaymentStatus: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");

		axios
			.post(config.server + "/updatePaymentStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllScrapingRequests: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getAllScrapingRequests", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAlladminReports: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getAllAdminsReport", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getScrapingEditResult: function (data, callback) {
		var adminToken = cookie.readCookie("superuser");
		axios
			.post(config.server + "/getScrapingEditResult", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getEditNotifications: function (data, callback) {

		axios
			.post(config.server + "/getEditNotifications", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getLocationEdits: function (data, callback) {

		axios
			.post(config.server + "/getLocationEdits", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateNotification: function (data, callback) {

		axios
			.post(config.server + "/updateNotification", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateLocationEdit: function (data, callback) {

		axios
			.post(config.server + "/updateLocationEdit", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editAccount: function (data, callback) {
		axios
			.post(config.server + "/editAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationEditHistoryCsv: function (data, callback) {
		axios
			.post(config.server + "/getLocationEditHistoryCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationImages: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/getLocationImages?profileId=" +
				profileId +
				"&locationId=" +
				locationId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleAccounts: function (data, callback) {
		axios
			.post(config.server + "/getGoogleAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveAuthorizedAccounts: function (data, callback) {
		axios
			.post(config.server + "/saveAuthorizedAccounts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleLocations: function (data, callback) {
		axios
			.post(config.server + "/getGoogleLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getInitialFetchStatus: function (profileId, requestId, callback) {
		axios
			.get(
				config.server +
				"/getInitialFetchStatus?profileId=" +
				profileId +
				"&requestId=" +
				requestId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveAuthorizedLocations: function (data, callback) {
		axios
			.post(config.server + "/saveAuthorizedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFetchSummary: function (profileId, userId, requestId, callback) {
		axios
			.get(
				config.server +
				"/getFetchSummary?profileId=" +
				profileId +
				"&userId=" +
				userId +
				"&requestId=" +
				requestId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateAccounts: function (profileId, userId, requestId, callback) {
		axios
			.get(
				config.server +
				"/activateAccounts?profileId=" +
				profileId +
				"&userId=" +
				userId +
				"&requestId=" +
				requestId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateIntegration: function (data, callback) {
		axios
			.post(config.server + "/updateGoogleAccountIntegration", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	activateSupressLocation: function (data, callback) {
		axios
			.post(config.server + "/suppressLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateLocation: function (data, callback) {
		axios
			.post(config.server + "/editAuthorizedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleLocationsForAccount: function (data, callback) {
		axios
			.post(config.server + "/getGoogleLocationsForAccount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	uploadBulkFiles: function (data, callback) {
		axios
			.post(config.server + "/uploadBulkFiles", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFileUploadHistory: function (data, callback) {
		axios
			.post(config.server + "/getFileUploadHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFilterTagCsv: function (profileId, domainName, callback) {
		axios
			.get(
				config.server +
				"/getFilterTagCsv?profileId=" +
				profileId +
				"&domainName=" +
				domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGmbDataConnection: function (data, callback) {
		axios
			.post(config.server + "/getGmbDataConnection", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSourceLocations: function (data, callback) {
		axios
			.post(config.server + "/getSourceLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveGmbDataConnection: function (data, callback) {
		axios
			.post(config.server + "/saveGmbDataConnection", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createFacebookPost: function (data, callback) {
		axios
			.post(config.server + "/createFacebookPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFacebookPosts: function (profileId, callback) {
		axios
			.get(config.server + "/getFacebookPosts?profileId=" + profileId, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSyncHistory: function (data, callback) {
		axios
			.post(config.server + "/getSyncHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPubSubStatus: function (data, callback) {
		axios
			.post(config.server + "/getPubSubStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createWidget: function (data, callback) {
		axios
			.post(config.server + "/createWidget", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWidgets: function (data, callback) {
		axios
			.post(config.server + "/getWidgets", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteWidget: function (profileId, widgetId, callback) {
		axios
			.get(
				config.server +
				"/deleteWidget?profileId=" +
				profileId +
				"&widgetId=" +
				widgetId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateWidget: function (data, callback) {
		axios
			.post(config.server + "/updateWidget", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBulkAttributes: function (data, callback) {
		axios
			.post(config.server + "/validateBulkEditRequest", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkEditLocations: function (data, callback) {
		axios
			.post(config.server + "/bulkEditLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBulkEditHistory: function (data, callback) {
		axios
			.post(config.server + "/getBulkEditHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	acceptInvite: function (profileId, userId, urlName, callback) {
		axios
			.get(
				config.server +
				"/acceptInvite?profileId=" +
				profileId +
				"&userId=" +
				userId +
				"&domainName=" +
				urlName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateProfileVariables: function (data, callback) {
		axios
			.post(config.server + "/updateProfileVariables", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateLocationDate: function (data, callback) {
		axios
			.post(config.server + "/updateLocationDateStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateUserDetails: function (data, callback) {
		axios
			.post(config.server + "/updateUserDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadPostHistory: function (data, callback) {
		axios
			.post(config.server + "/downloadPostHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				let response = resp.data;
				response.status = resp.status;
				callback(null, response);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadSingleEntityTag: function (data, callback) {
		axios
			.post(config.server + "/getLocationsByGroupCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				let response = resp.data;
				response.status = resp.status;
				callback(null, response);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadBlockedDoamin: function (data, callback) {
		axios
			.post(config.server + "/getBlockedDomainsCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	// deleteBlockedPublicEmailDomain: function (data, callback) {
	//     var TOKEN = cookie.readCookie("lctoken");
	//     axios.delete(config.server + "/deleteBlockedPublicEmailDomain", data,
	//         {
	//             headers: {
	//                 "Token": TOKEN,
	//                 "Content-Type": "application/json"
	//             }
	//         })
	//         .then((resp) => {
	//             callback(null, resp.data)
	//         })
	//         .catch((err) => {
	//             callback(err.response, null)
	//         })
	// },
	// getBlockedSpamDomain: function (data, callback) {
	//     var TOKEN = cookie.readCookie("lctoken");
	//     axios.post(config.server + "/getBlockedSpamDomain", data,
	//         {
	//             headers: {
	//                 "Token": TOKEN,
	//                 "Content-Type": "application/json"
	//             }
	//         })
	//         .then((resp) => {
	//             callback(null, resp.data)
	//         })
	//         .catch((err) => {
	//             callback(err.response, null)
	//         })
	// },
	// deleteBlockedSpamDomain: function (data, callback) {
	//     var TOKEN = cookie.readCookie("lctoken");
	//     axios.delete(config.server + "/deleteBlockedSpamDomain", data,
	//         {
	//             headers: {
	//                 "Token": TOKEN,
	//                 "Content-Type": "application/json"
	//             }
	//         })
	//         .then((resp) => {
	//             callback(null, resp.data)
	//         })
	//         .catch((err) => {
	//             callback(err.response, null)
	//         })
	// },
	bulkDeletePosts: function (data, callback) {
		axios
			.post(config.server + "/bulkDeletePosts", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteBulkEdit: function (data, callback) {
		axios
			.post(config.server + "/deleteBulkEditRequest", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getNotificationEditedFields: function (data, callback) {
		axios
			.post(config.server + "/getNotificationEditedFields", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getResponseTimeHistogram: function (data, callback) {
		axios
			.post(config.server + "/getResponseTimeHistogram/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCommentHistogram: function (data, callback) {
		axios
			.post(config.server + "/getCommentHistogram/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllReviewSummaryReport: function (data, callback) {
		axios
			.post(config.server + "/getAllReviewSummaryReport/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWordHistogram: function (data, callback) {
		axios
			.post(config.server + "/getWordHistogram/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	addReviewAssignee: function (data, callback) {
		axios
			.post(config.server + "/addReviewAssignee/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateReviewAssignee: function (data, callback) {
		axios
			.post(config.server + "/updateReviewAssignee/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteReviewAssignee: function (data, callback) {
		axios
			.post(config.server + "/deleteReviewAssignee/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAssignedReviews: function (data, callback) {
		axios
			.post(config.server + "/getAssignedReviews/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllFilterTags: function (data, callback) {
		axios
			.post(config.server + "/getAllFilterTags/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateFilterTag: function (tagObject, callback) {
		axios
			.post(config.server + "/updateFilterTag", tagObject, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalpostSampleButtonLink: function (data, callback) {
		axios
			.post(config.server + "/getLocalpostSampleButtonLink", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCleanupHistory: function (data, callback) {
		axios
			.post(config.server + "/getReviewCleanupHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updateBulkEditPost: function (data, callback) {
		axios
			.post(config.server + "/updateBulkEditPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	updateScheduledLocalPost: function (data, callback) {
		axios
			.post(config.server + "/updateScheduledLocalPost", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllImageLocation: function (data, callback) {
		axios
			.post(config.server + "/getAllLocationImages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	getLocationImageCount: function (data, callback) {
		axios
			.post(config.server + "/getLocationImageCount", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	deleteImage: function (data, callback) {
		axios
			.post(config.server + "/deleteImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	flagImage: function (data, callback) {
		axios
			.post(config.server + "/flagImage", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	addMediaTag: function (data, callback) {
		axios
			.post(config.server + "/addMediaTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	createAiTone: function (data, callback) {
		axios
			.post(config.server + "/createAIPersonalityTone", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	removeMediaTag: function (data, callback) {
		axios
			.post(config.server + "/removeMediaTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	getLocationWiseImages: function (data, callback) {
		axios
			.post(config.server + "/getLocationWiseImages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	createAutomationRules: function (data, callback) {
		axios
			.post(config.server + "/createAutomationRule", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	GetAutomationRule: function (data, callback) {
		axios
			.post(config.server + "/getAutomationRules", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAutomationRule: function (data, callback) {
		axios
			.post(config.server + "/updateAutomationRule", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAutomationRule: function (data, callback) {
		axios
			.post(config.server + "/deleteAutomationRule", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAllMediaTags: function (data, callback) {
		axios
			.post(config.server + "/getAllMediaTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((response) => callback(null, response.data))
			.catch((error) => callback(error.response, null));
	},
	getLocationFriendlyName: function (data, callback) {
		axios
			.post(config.server + "/getLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createKeywordGroup: function (data, callback) {
		axios
			.post(config.server + "/createKeywordGroup", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteKeywordGroup: function (data, callback) {
		axios
			.post(config.server + "/deleteKeywordGroup", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getKeywordGroups: function (data, callback) {
		axios
			.post(config.server + "/getKeywordGroups", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateKeywordGroups: function (data, callback) {
		axios
			.post(config.server + "/updateKeywordGroup", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkUploadImages: function (data, callback) {
		axios
			.post(config.server + "/bulkUploadImages", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getImageUploadHistory: function (data, callback) {
		axios
			.post(config.server + "/getImageUploadHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteImageUploadHistory: function (data, callback) {
		axios
			.post(config.server + "/deleteImageUploadHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createTeam: function (data, callback) {
		axios
			.post(config.server + "/createTeam", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteTeam: function (data, callback) {
		axios
			.post(config.server + "/deleteTeam", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTeams: function (data, callback) {
		axios
			.post(config.server + "/getTeams", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateTeam: function (data, callback) {
		axios
			.post(config.server + "/updateTeam", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateReviewShakeFetchStatus: function (data, callback) {
		axios
			.post(config.server + "/updateReviewShakeFetchStatus/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationDataFetch: function (profileId, locationId, callback) {
		axios
			.get(
				config.server +
				"/getLocationFetchingStatus?profileId=" +
				profileId +
				"&locationId=" +
				locationId,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateTeamMemberAccess: function (data, callback) {
		axios
			.post(config.server + "/updateTeamMemberAccess/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUsersAndTeams: function (data, callback) {
		axios
			.post(config.server + "/getUsersAndTeams/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getTeamReviews: function (data, callback) {
		axios
			.post(config.server + "/getTeamReviews/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUserTeams: function (data, callback) {
		axios
			.post(config.server + "/getUserTeams/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateUserDomain: function (data, callback) {
		axios
			.post(config.server + "/updateUserDomain/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateProfileDomain: function (data, callback) {
		axios
			.post(config.server + "/updateProfileDomain/", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateIndexedLocations: function (data, callback) {
		axios
			.post(config.server + "/updateIndexedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUnmappedLocations: function (data, callback) {
		axios
			.post(config.server + "/getUnmappedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getMappedLocations: function (data, callback) {
		axios
			.post(config.server + "/getMappedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getPaginatedMappedLocations: function (data, callback) {
		axios
			.post(config.server + "/getPaginatedMappedLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	dragAndDropLocations: function (data, callback) {
		axios
			.post(config.server + "/dragAndDropLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createMasterLocation: function (data, callback) {
		axios
			.post(config.server + "/createMasterLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteMasterLocation: function (data, callback) {
		axios
			.post(config.server + "/deleteMasterLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	hideMasterLocation: function (data, callback) {
		axios
			.post(config.server + "/manageMasterVisibility", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editMasterLocation: function (data, callback) {
		axios
			.post(config.server + "/editMasterLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveLocationMapping: function (data, callback) {
		axios
			.post(config.server + "/saveLocationMapping", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationMappingStatus: function (data, callback) {
		axios
			.post(config.server + "/getLocationMappingStatus", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	cancelSaveMapping: function (data, callback) {
		axios
			.post(config.server + "/cancelSaveMapping", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUnmappedLocationsSources: function (data, callback) {
		axios
			.post(config.server + "/getUnmappedLocationsSources", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateManagePermission: function (data, callback) {
		axios
			.post(config.server + "/updateManagePermission", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	update2FAPermission: function (data, callback) {
		axios
			.post(config.server + "/updateUserInfo", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	reportManagementDownload: function (profileId, domainName, callback) {
		axios
			.get(
				config.server +
				"/reportManagementDownload" +
				"?profileId=" +
				profileId +
				"&domainName=" +
				domainName,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	googlePlayClientCredentials: function (data, callback) {

		axios
			.post(config.server + "/googlePlayClientCredentials", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	appStoreClientCredentials: function (data, callback) {

		axios
			.post(config.server + "/appStoreClientDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	getAllPersonalityTones: function (data, callback) {
		axios
			.post(config.server + "/getAllPersonalityTones", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},

	deleteAiTone: function (data, callback) {
		axios
			.post(config.server + "/deleteAIPersonalityTone", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editAiTone: function (data, callback) {
		axios
			.post(config.server + "/editAIPersonalityTone", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadAiTone: function (data, callback) {
		axios
			.post(config.server + "/openAiSettingsDownload", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	GetReviewDetails: function (data, callback) {
		axios
			.post(config.server + "/getReviewDetails", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateUserName: function (data, callback) {
		axios
			.post(config.server + "/updateUsername", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	searchKeywordDownload: function (data, callback) {
		axios
			.post(config.server + "/searchKeywords", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWalmartAuditHistory: function (data, callback) {
		axios
			.post(config.server + "/getWalmartAuditHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWalmartAuditSummary: function (data, callback) {
		axios
			.post(config.server + "/getWalmartAuditSummary", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	downloadWalmartAuditHistory: function (data, callback) {
		axios
			.post(config.server + "/downloadWalmartAuditHistory", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	bulkEditWalmartLocations: function (data, callback) {
		axios
			.post(config.server + "/bulkEditWalmartLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWalmartEditStatus: function (data, callback) {
		axios
			.post(
				config.server + "/getWalmartEditStatus",
				data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAccountUpdateHistory: function (data, callback) {
		axios
			.post(
				config.server + "/getAccountUpdateHistory",
				data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	editWalmartLocation: function (data, callback) {
		axios
			.post(config.server + "/editWalmartLocation", data, {
				headers: generateHeaderWithToken(),

			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSourceLocation: function (data, callback) {
		axios
			.post(config.server + "/getSourceLocations", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAppleLocation: function (data, callback) {
		axios
			.put(config.server + "/updateAppleLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getSocialMediaUploadCsv: function (data, callback) {
		axios
			.post(config.server + "/getSocialMediaUploadCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	viewLocationFilterTags: function (data, callback) {
		axios
			.post(config.server + "/viewLocationFilterTags", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateAppleLocation: function (data, callback) {
		axios
			.put(config.server + "/updateAppleLocation", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getBusinessTeamUsers: function (data, callback) {
		axios
			.post(config.server + "/getBusinessTeamUsers", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getGoogleImportedLocations: function (data, callback) {
		axios
			.post(config.server + "/getGoogleImportedLocations", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkspaceDataCsv: function (data, callback) {
		axios
			.post(config.server + "/getWorkspaceDataCsv", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getProfileDataCsv: function (data, callback) {
		axios
			.post(config.server + "/getProfileDataCsv", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	importGoogleLocations: function (data, callback) {
		axios
			.post(config.server + "/importGoogleLocations", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteAppleLocation: function (data, callback) {
		axios
			.post(config.server + "/deleteAppleLocation", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getAppleSummary: function (data, callback) {
		axios
			.post(config.server + "/getAppleSummary", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getUserDataCsv: function (data, callback) {
		axios
			.post(config.server + "/getUserDataCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getWorkspaceDataCsv: function (data, callback) {
		axios
			.post(config.server + "/getWorkspaceDataCsv", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateImageAssets: function (data, callback) {
		axios
			.post(config.server + "/updateImageAssets", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocationsList: function (data, callback) {
		axios
			.post(config.server + "/getLocationsList", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getImageAssets: function (data, callback) {
		axios
			.post(config.server + "/getImageAssets", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getLocalpostSampleData: function (data, callback) {
		axios
			.post(config.server + "/getLocalpostSampleData", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateImageSettings: function (data, callback) {
		axios
			.post(config.server + "/updateImageSettings", data, {
				headers: generateHeaderWithToken(),
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getCalendarEvents: function (data, callback) {
		axios
			.post(config.server + "/getCalenderEvents", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteImageAssets: function (data, callback) {
		axios
			.delete(config.server + "/deleteImageAssets", {
				headers: generateHeaderWithToken(),
				data,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateCalenderEvent: function (data, callback) {
		axios
			.post(config.server + "/updateCalenderEvent", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getNavigation: function (domainName, profileId, callback) {
		axios
			.get(
				config.server +
				"/getNavigation" +
				"?domainName=" +
				domainName +
				(profileId ? "&profileId=" + profileId : ""),
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	updateNavigation: function (data, callback) {
		axios
			.post(
				config.server + "/updateNavigation", data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	createNavigation: function (data, callback) {
		axios
			.post(
				config.server + "/createNavigation", data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteNavigation: function (data, callback) {
		axios
			.delete(config.server + "/deleteNavigation", {
				headers: generateHeaderWithToken(),
				data,
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	deleteCalenderEvent: function (data, callback) {
		axios
			.post(config.server + "/deleteCalenderEvent", data, {
				headers: generateHeaderWithToken(),
				withCredentials: false
			})
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	getFilterComposer: function (domainName, profileId, type, callback) {
		axios
			.get(
				config.server +
				"/getFilterComposer" +
				"?domainName=" +
				domainName +
				"&profileId=" + profileId + "&type=" + type,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	saveFilterComposer: function (data, callback) {
		axios
			.post(
				config.server + "/saveFilterComposer", data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
	resetFilterComposer: function (data, callback) {
		axios
			.post(
				config.server + "/resetFilterComposer", data,
				{
					headers: generateHeaderWithToken(),
				},
			)
			.then((resp) => {
				callback(null, resp.data);
			})
			.catch((err) => {
				callback(err.response, null);
			});
	},
};

export default new APIClient();
